import React from 'react';
import Typography from '../../../base/Typography';
import Colors from '../../../theme/colors';
import { Container, Row, Col } from '../../../base/Grid';

import {
  IconStyled,
  LinkStyled,
} from './styles';

export const ThankYouModuleComponent = ({
  userName,
}) => (
  <Container id='in-page-lead-thank-you-view'>
    <Row align='center'>
      <IconStyled />
    </Row>
    <Row align='center'>
      <Typography
        component='p'
        variant='h4'
        color={Colors.neutral.white}>
        Got it&#33; Thanks, {userName}.
      </Typography>
    </Row>
    <Row align='center'>
      <Col xsmall={12} medium={10}>
        <Typography
        component='p'
        color={Colors.neutral.white}>
          We&#39;re excited to work with you. Your advisor will reach out soon to talk about your goals.
          Until then, check out&nbsp;
          <LinkStyled
          id='in-page-lead-form-guide-on-what-to-expect-link'
          href='/email-landing/prospect/get-the-most-from-your-first-advisor-meeting?utm_source=NMCOM&utm_medium=LandingPage&utm_term=na&utm_campaign=FAFA&utm_content=Let%27s_Get_Ready'
          variant='primary'>
            our guide on what you can expect
          </LinkStyled>
        &nbsp;from your first meeting and what to have handy.
        </Typography>
      </Col>
    </Row>
  </Container>
);

export default ThankYouModuleComponent;
